export default "__VITE_ASSET__Dovdy6YF__"